/**
 * TeamHeaderCard.js
 *
 * Displays the team name (top-left) and the budget left (bottom-right).
 * Uses the Card UI layout and stays clean across screen sizes.
 */

import React from "react";
import Card, { CardHeader, CardTitle, CardContent } from "../../../components/ui/Card";

const TeamHeaderCard = ({ name, color, budgetLeft }) => {
    const textColor = color?.text === "text-white" ? "white" : "black";

    return (
        <Card
            className={`
                ${color?.bg || "bg-zinc-600"}
                border-zinc-700
                shadow-md
                rounded-2xl
                text-${textColor}
                flex flex-col justify-between
                h-40 sm:h-48
            `}
        >
            {/* --- Top Left: Team Name --- */}
            <CardHeader className="px-6 pt-4 pb-0 text-left">
                <CardTitle
                    className={`text-xl sm:text-2xl font-semibold text-${textColor}`}
                >
                    {name || "Your Team"}
                </CardTitle>
            </CardHeader>

            {/* --- Bottom Right: Budget Left --- */}
            <CardContent className="flex justify-end items-end px-6 pb-4">
                <div className="text-left">
                    <span
                        className={`text-${textColor} text-sm uppercase tracking-wide opacity-80`}
                    >
                        Left
                    </span>
                    <div
                        className={`text-6xl sm:text-6xl font-extrabold leading-none text-${textColor}`}
                    >
                        ₹{budgetLeft ?? 0}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default TeamHeaderCard;